<template>
  <modal :show="showModal">
    <h6 slot="header" class="modal-title" id="modal-title-notification">Your attention is required</h6>

    <div class="text-center">
      <h3 class="mt-4">{{ message }}</h3>
    </div>

    <template slot="footer">
      <div class="col-md-12 text-center">
        <base-button
          outline
          :type="type ? type : 'primary'"
          @click="onNegativeClicked()"
        >{{ negativeText }}</base-button>
        <base-button
          :type="type ? type : 'primary'"
          :loading="isLoading"
          @click="onPositiveClicked()"
        >{{ positiveText }}</base-button>
      </div>
    </template>
  </modal>
</template>
<script>
export default {
  name: 'confirmation-modal',
  props: [
    'message',
    'positiveText',
    'negativeText',
    'showModal',
    'isLoading',
    'type'
  ],
  data() {
    return {
      showClose: this.showModal
    }
  },
  methods: {
    onPositiveClicked() {
      this.$emit('onPositiveClicked')
    },
    onNegativeClicked() {
      this.$emit('onNegativeClicked')
    }
  }
}
</script>
